var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"id":"app"}},[_c('navbar',{attrs:{"first":_vm.first,"second":_vm.second,"brand":_vm.brand}}),_c('router-view',{staticStyle:{"flex-grow":"1"}}),_c('foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }